export const environment = {
  production: true,
  useStubInterceptor: false,
  disableLongRunningTasks: false,
  apiUrl: '/move-api/rest',
  errorMessageDurationMs: 4000,
  searchOptionsCacheTimeMs: 8 * 60 * 60 * 1000, // 8 hours
  pickUpListPollingInterval: 5000, // 5 seconds
  animations: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts